import React, { FC } from 'react';

import { Typography } from '@mui/material';
import MyAvatar from 'src/components/atoms/Avatar';
import { getAssetUrl } from 'src/helpers/utils';

import { BundleCourseCardInstructorBox } from './style';

type BundleCourseCardInstructorProps = {
  fullName: string;
  imageUrl: string;
};

const BundleCourseCardInstructor: FC<BundleCourseCardInstructorProps> = ({ fullName, imageUrl }) => {
  return (
    <BundleCourseCardInstructorBox sx={{ marginTop: '8px' }}>
      <MyAvatar
        className="avatar-instructor"
        errorImage={`${getAssetUrl('thumbnail-instructor.jpg')}`}
        alt={fullName}
        src={imageUrl}
      />
      <Typography className="instructor-info">{fullName}</Typography>
    </BundleCourseCardInstructorBox>
  );
};

export default BundleCourseCardInstructor;
